import { Box, Tooltip } from "@mui/material";

// Barra de abas que QUEBRA em várias linhas (todas visíveis, sem scroll/seta),
// com um ponto de aviso nas abas que têm pendências.
export default function TabsBar({ tabs, value, onChange }) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, px: 1, pt: 1, borderBottom: 1, borderColor: "divider" }}>
      {tabs.map((t, i) => {
        const ativo = i === value;
        return (
          <Box
            key={i}
            onClick={() => onChange(i)}
            sx={{
              cursor: "pointer", userSelect: "none", px: 2, py: 1.1, borderRadius: "8px 8px 0 0",
              fontSize: 14, fontWeight: ativo ? 700 : 500,
              color: ativo ? "primary.main" : "text.secondary",
              borderBottom: "2px solid", borderColor: ativo ? "primary.main" : "transparent",
              display: "flex", alignItems: "center", gap: 0.75,
              "&:hover": { color: "primary.main", bgcolor: "action.hover" },
            }}
          >
            {t.label}
            {t.pendente && (
              <Tooltip title="Há campos obrigatórios a preencher">
                <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: "warning.main" }} />
              </Tooltip>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
